import { useEffect,useState } from 'react';

import useIsFirstRender from '@/hooks/useIsFirstRender';
import useTranslations from '@/i18n/useTranslations';
import InfoIconArtwork from '@/shared-components/icons/components/public/InfoIconArtwork';

import UploadSecondaryPictures from './components/UploadSecondaryPictures';
import RenderSecondaryPictures from './render-secondary-pictures';

import './index.css';

export default function SecondaryPictures({ formError, setFormError, previewMode, fillWith, onChange, disabled = false, }) {
  const t = useTranslations('common.forms.add_artwork');
  const [secondaryPictures, setSecondaryPictures] = useState(fillWith); 
  const [isInfoIconOpen, setIsInfoIconOpen] = useState(false);
  const isFirstRender = useIsFirstRender();

  useEffect(()=>{
    if(!isFirstRender) {
      onChange(secondaryPictures.filter(picture => !picture.loading));
    }
  }, [secondaryPictures]);

  return (
    <>
      {(!previewMode || secondaryPictures.length > 0) && (
        <h2 className={`add-artwork-media-form__heading${disabled ? ' is-disabled' : ''}`}>
          {t('secondary_pictures_title')}
          <InfoIconArtwork
            className="step-accordeon-step-header__info-icon"
            onClick={() => setIsInfoIconOpen((current) => !current)}
            open={isInfoIconOpen}
            header={t('secondary_pictures_title')}
            description={t('secondary_pictures_info')}
          />
        </h2>
      )}
      {
        secondaryPictures.length > 0 ?
          <div className={`add-artwork-media-form__secondary-pictures-container${disabled ? ' is-disabled' : ''}`}>
            <RenderSecondaryPictures
              disabled={disabled}
              pictures={secondaryPictures} 
              setPictures={setSecondaryPictures} 
              pictureIds={secondaryPictures.map(picture => picture.image_id)} 
              previewMode={previewMode}
            />

            {(!previewMode && secondaryPictures.length < 4) && (
              <UploadSecondaryPictures
                disabled={disabled}
                secondaryPictures={secondaryPictures}
                setSecondaryPictures={setSecondaryPictures}
                formError={formError}
                setFormError={setFormError}
                internal
              />
            )}
          </div>
          :
          !previewMode && (
            <UploadSecondaryPictures
              disabled={disabled}
              secondaryPictures={secondaryPictures}
              setSecondaryPictures={setSecondaryPictures}
              formError={formError}
              setFormError={setFormError}
            />
          )
      }
    </>
  );
}
